export class ObjectSetRaceObject {
}
export class ObjectSet {
    constructor() {
        this.objectSet = [];
    }
}
export class ObjectSetObject {
}
export class ObjectSetObjectAttributesV2 {
}
